module.exports = __webpack_public_path__ + "static/media/pwa3.9625e865.png";